(function (ns, fetch) {

    var loadScript = function (url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    var loadStyle = function (url) {
        var style = document.createElement("link")
        style.type = "text/css"
        style.media = "all"
        style.rel = "stylesheet"
        style.href = url
        document.getElementsByTagName("head")[0].appendChild(style)
    };
  
  	let ssppCurrency = {
      money_format : "${amount}",
      formatMoney : function(cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        var value = '';
        var placeholderRegex = /\{\s*(\w+)\s*\}/;

        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
           return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal   = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return 0; }

          number = (number/100.0).toFixed(precision);

          // var parts   = number.split('.'),
          //     dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          //     cents   = parts[1] ? (decimal + parts[1]) : '';

          // return dollars + cents;

          return Math.ceil(number)
        }

        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }
    }

    let ssppApp = function ($) {
        var isCartUpdated = false;
        let sspp = {
            settings: {
              listItemWrapper: 't4s-mini_cart__item',
              hideToggle: false,
              toggleWrapper:'t4s-mini_cart__tool',
              oldPPProductId : 0,
              currentPPProductId: 0
            },
            init: async function () {
                ssppCart.hideCart("."+sspp.settings.listItemWrapper)
              
                await this.getPackage()

				this.getCart(ssppCart.insertPackageIntoCart)

                let formGlobal = $('form[action="/cart"]') || $('form[action="/checkout"]')

                if (formGlobal.html() != undefined) {
                    if (localStorage.getItem('_ssppOption') === null) {
                        localStorage.setItem('_ssppOption', true)
                    }
                }

                formGlobal.on('submit', function () {
                    localStorage.removeItem('__isSSPPLoad')
                })

                $('body').on('click', '.package-protection-close-btn, .package-protection-cancel-btn', function () {
                    $('.package-protection-info-popup').hide();
                })

                $('body').on('click', '.package-protection-continue-btn', function () {
                    $('input#offcanvas-cart-footer-upsell-checkbox').prop('checked', false);
                    sspp.getCart(ssppCart.togglePackageProtection)
                })

                $('body').on('click', "a:contains('LABL'), a[href*='labl-protect']", function (e) {
                    e.preventDefault(); e.stopPropagation();
                })
            },
            _getCookie: (value) =>{
                let name = value + "="
                let ca = document.cookie.split(';')
                for(let i = 0; i < ca.length; i++) {
                  let c = ca[i]
                  while (c.charAt(0) == ' ') {
                    c = c.substring(1)
                  }
                  if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length)
                  }
                }
                return ""
            },
            getPackage: async function () {
                let response = await fetch('/products/labl-protect.js');
                let data = await response.json()
                localStorage.setItem('sspp', JSON.stringify(data))
            },
            getCart: function (callback) {
                $.getJSON('/cart.js', callback);
            },
            AddPackageToCart: function (variant) {
              $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                  items: [
                    {
                      quantity: 1,
                      id: variant.id
                    }
                  ]
                },
                success: function (response) {
                  localStorage.removeItem('__isSSPPLoad')
                  localStorage.setItem('_ssppvId', variant.id)
                  sspp.getCart(ssppCart.updatePackageCart)
                  
                  /** Custom Script */
                  sspp.getCart(ssppCart.updateSSPPPrice)
                  $.getJSON('/cart.js', function(cart){
                      $('.t4s-btn__checkout').find('.text').html(ssppCurrency.formatMoney(cart.items_subtotal_price, "${amount}")+' '+cart.currency)
                      $('.pp-price').html(window.ssppprice)
                  });

                  ssppCart.refreshCartList()
                }
              })
            },
            UpdatePackageToCart: function (id) {
                $.ajax({
                    url: '/cart/change.js',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        quantity: 1,
                        id: id
                    },
                    success: function (response) {
                        localStorage.removeItem('__isSSPPLoad')
                    }
                })
            },
            removePackageFromCart: function (id) {
                fetch('/cart/change.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({quantity: 0, id: id.toString()}),
                }).then((response) => response.json())
                .then((data) => {
                  localStorage.removeItem('__isSSPPLoad')
                  sspp.getCart(ssppCart.updatePackageCart)
                  $.getJSON('/cart.js', function(cart){
                      $('.t4s-btn__checkout').find('.text').html(ssppCurrency.formatMoney(cart.items_subtotal_price, "${amount}")+' '+cart.currency)
                      $('.pp-price').html(window.ssppprice)
                  });

                  ssppCart.refreshCartList()
                });
            },
            ajaxLoadEndListener: function () {
                //var package = JSON.parse(localStorage.getItem('sspp'))
                if (this._url == '/cart/add.js') {
                  sspp.getCart(ssppCart.updatePackageCart)
                }
                this.removeEventListener('loadend', sspp.ajaxLoadEndListener)
            },
            convertPackagePrice: function (variantId) {
              var updatedPPPrice = $('.pp-price').clone().attr("data-product-variant-id", variantId)
              updatedPPPrice.attr('data-role', 'price')
              updatedPPPrice.attr('data-variant', 'without-currency')
              var ppParent = $('.pp-price').parent()
              $('.pp-price').remove()
              ppParent.append(updatedPPPrice)
            }
        }

        let ssppCart = {
            insertPackageIntoCart: function (cart) {
                localStorage.setItem('_ssppToken', cart.token)
                var package = JSON.parse(localStorage.getItem('sspp'))
                var cartPrice = ssppCart.getCartTotal(cart, true)
                var ssppVariant = ssppCart.getMatchedVariant(cartPrice)
                window.ssppprice = ssppVariant.public_title
                var ssppSettings = sspp.settings
                var sspptheme = ssppSettings.cartTheme

                if (localStorage.getItem('sspp') !== null) {

                    if (localStorage.getItem('_ssppOption') === 'true') {
                        var current_item = cart.items.find(i => i.product_id === package.id)
                        if (current_item == undefined) {
                            sspp.getCart(ssppCart.updatePackageCart)
                            localStorage.removeItem('__isSSPPLoad')
                        } else {
                            window.ssppprice = current_item.variant_title
                        }
                    }

                    /*Hide Page Item*/
                    var cartItemClass = ssppSettings.listItemWrapper
                    cartItemClassArray = cartItemClass.split(",")

                    if (cartItemClassArray.length > 1) {
                        var cartItemClass = []
                        $.each(cartItemClassArray, (a, b) => {
                            cartItemClass.push('.' + b.trim())
                        })
                        cartItemClass = cartItemClass.join(",")
                    } else {
                        cartItemClass = '.' + cartItemClass
                    }


                    /*Hide Page Item*/

                    var formInterval = setInterval(() => {
                                                   
                        if($('.pp-price').html() == ""){                           
                        	sspp.getCart(ssppCart.updateSSPPPrice)
                    	}
                        ssppCart.hideCart(cartItemClass)
                        
                    	let form = $('form[action="/cart"]') || $('form[action="/checkout"]')
                        if (ssppSettings.hideToggle == true) {
                            ssppCart.hideCart(cartItemClass)
                        } else {
                            // do nothing
                        }
                        $("a:contains('LABL')").parents(cartItemClass).find(".quantity").parent().hide()
                      
                        if ($('body').hasClass('template-cart') && form.length > 1) {
                            $.each(form, function () {
                                if ($(this).html() != undefined) {
                                    if ($('body').find('.pp-container').html() == undefined) {
                                        current_item = cart.items.find(i => i.product_id === package.id)

                                        if (cart.items) {
                                            /*Hide AJAX Item*/
                                            if (ssppSettings.hideToggle == true) {
                                                ssppCart.hideCart(cartItemClass)
                                            }

                                            /*Hide AJAX Item*/

                                            sspp.getCart(ssppCart.updateSSPPPrice)

                                            var sspp_template = ssppCart.getPackageTemplate(ssppVariant);
                                            var ssppForm_width = $(this).width()

                                            /*Dynamic Object Handler*/
                                            
                                            var packageProtectionWrapperClass = ssppSettings.toggleWrapper
                                            var ppheight = 0;
                                            packageProtectionWrapperArray = packageProtectionWrapperClass.split(",")
                                            if (packageProtectionWrapperArray.length > 1) {
                                                var ppClass = []
                                                $.each(packageProtectionWrapperArray, (a, b) => {
                                                    ppClass.push('.' + b.trim())
                                                    ppheight = $('.' + b.trim()).css("height")
                                                    if ($(this).find('.' + b.trim()).html() != undefined) {
                                                        $( sspp_template ).insertBefore( $(this).find('.' + b.trim()) );
                                                    }
                                                })
                                            } else {
                                                packageProtectionWrapperClass = '.' + packageProtectionWrapperClass
                                                $( sspp_template ).insertBefore( packageProtectionWrapperClass );
                                            }

                                            $('.package-protection-container').addClass(sspptheme)
    										$('body').off("click","#offcanvas-cart-footer-upsell-checkbox").on("click", "#offcanvas-cart-footer-upsell-checkbox", function (e) {
                                              if($(this).is(':checked')){
                                                  localStorage.setItem('_ssppOption', true);
                                                  sspp.getCart(ssppCart.updatePackageCart);  
                                              } else {
                                                  ssppCart.confirmTogglePackageProtection()
                                                  localStorage.setItem('_ssppOption', false);
                                              }
                                            })
                                            
                                            if (ssppForm_width < 350) {
                                                ppheight = parseInt(ppheight, 10)

                                                $(this).find('.package-protection-container, .package-protection-right').addClass('small')
                                                $(this).find('.package-protection-container').css({ height: '85px' })
                                            }
                                            if ($("#packageProtectionInfoPopup").html() == undefined) {
                                                var sspp_opt = ssppCart.buildPopupWindow();
                                                $('body').append(sspp_opt)
                                            }
                                            ssppCart.setSSPPHeight()
                                        }
                                    }
                                }
                            })
                        } else {
                            if (form.html() != undefined) {
                                if ($('.pp-container').html() == undefined) {
                                    current_item = cart.items.find(i => i.product_id === package.id)
                                    
                                    if (cart.items) {
                                      
                                        sspp.getCart(ssppCart.updateSSPPPrice)

                                        var sspp_template = ssppCart.getPackageTemplate(ssppVariant);
                                        var ssppForm_width = form.width()

                                        /*Dynamic Object Handler*/
                                        var packageProtectionWrapperClass = ssppSettings.toggleWrapper
                                        var ppheight = 0;
                                        packageProtectionWrapperArray = packageProtectionWrapperClass.split(",")
                                        if (packageProtectionWrapperArray.length > 1) {
                                            var ppClass = []
                                            $.each(packageProtectionWrapperArray, (a, b) => {
                                                ppClass.push('.' + b.trim())
                                                ppheight = $('.' + b.trim()).css("height")
                                            })
                                            packageProtectionWrapperClass = ppClass.join(",")
                                        } else {
                                            packageProtectionWrapperClass = '.' + packageProtectionWrapperClass
                                        }
                                        $( sspp_template ).insertBefore( packageProtectionWrapperClass );

                                        $('body').off("click", "#offcanvas-cart-footer-upsell-checkbox").on("click", "#offcanvas-cart-footer-upsell-checkbox", function (e) {
                                          if($(this).is(':checked')){
                                              localStorage.setItem('_ssppOption', true);
                                              sspp.getCart(ssppCart.updatePackageCart);  
                                          } else {
                                              ssppCart.confirmTogglePackageProtection()
                                          }
                                        })
                                        
                                        if (ssppForm_width < 350) {
                                            ppheight = parseInt(ppheight, 10)
                                            $('.package-protection-container').css({ height: '85px' })
                                            form.find('.package-protection-right').addClass('small')
                                        }
                                        if ($("#packageProtectionInfoPopup").html() == undefined) {
                                            var sspp_opt = ssppCart.buildPopupWindow();
                                            $('body').append(sspp_opt)
                                        }
                                        ssppCart.setSSPPHeight()
                                    }
                                }
                            }
                        }
                    }, 1000)
                }
            },
            updatePackageCart: function (cart) {
                var package = JSON.parse(localStorage.getItem('sspp'))
                var current_item = cart.items.find(i => i.product_id === package.id)
              
                if (localStorage.getItem('_ssppOption') === null) {
                    localStorage.setItem('_ssppOption', true)
                }

                if (localStorage.getItem('_ssppToken') === null) {
                    localStorage.setItem('_ssppToken', cart.token)
                }

                var _cartToken = localStorage.getItem('_ssppToken')
                var _ssppOption = localStorage.getItem('_ssppOption')

                if (_ssppOption === 'false' && _cartToken != cart.token) {
                    localStorage.setItem('_ssppOption', true)
                    localStorage.setItem('_ssppToken', cart.token)
                    _ssppOption = localStorage.getItem('_ssppOption')
                }

                if (package !== null && _ssppOption === 'true') {
                      const cartItemsWithoutIns = cart.items.filter(function (obj) {
                          return obj.vendor !== 'PackageProtection.com' && obj.requires_shipping !== false;
                      });

                      if(cartItemsWithoutIns.length == 0){
                        $("#offcanvas-cart-footer-upsell-checkbox").prop("checked", false)
                        
                        if(current_item != undefined){  
                          sspp.removePackageFromCart(current_item.variant_id)
                        }
                      } else {
                        $("#offcanvas-cart-footer-upsell-checkbox").prop("checked", true)
                        var cartPrice = ssppCart.getCartTotal(cart, true)
                        var priceTier = 1;
    
                        if (cartPrice > 10000) {
                            priceTier = 1 + (Math.ceil((cartPrice - 10000) / 1500))
                        }
                      
                        var variantSKU = "PPTIER" + priceTier.toString();
                        var matchedVariant = package.variants.find(v => v.sku.toLowerCase() === variantSKU.toLowerCase())
                      
                        if( matchedVariant == undefined ){
                          matchedVariant = package.variants[package.variants.length-1]
                        }

                        if(current_item == undefined && priceTier <= 100){
                          sspp.AddPackageToCart(matchedVariant)
                        } else if(current_item == undefined && priceTier > 100){
                          sspp.AddPackageToCart(matchedVariant)
                        } else { 
                          if(current_item.variant_id != matchedVariant.id || current_item.quantity > 1){  
                            sspp.removePackageFromCart(current_item.variant_id)
                          }
                        }
                      }
                  }
            },
            updateSSPPPrice: function (cart) {
                var package = JSON.parse(localStorage.getItem('sspp'))
                var cartPrice = ssppCart.getCartTotal(cart, true)
                var ssppVariant = ssppCart.getMatchedVariant(cartPrice)
                var sspp_price = ssppVariant.price
                var current_item = cart.items.find(i => i.product_id === package.id)
                if (current_item != undefined && current_item.quantity < 2) {
                    sspp_price = current_item.line_price
                }
              	$('.pp-price').text(ssppVariant.public_title)
                window.ssppprice = ssppVariant.public_title
            },
            hideCart: function (cartItemClass) {
                var itemRowDom = $(cartItemClass).find("a:contains('LABL')")
                itemRowDom.parents(cartItemClass).hide()
                itemRowDom.parents(cartItemClass).attr('style','display:none !important');
            },
            getMatchedVariant: function (cartPrice) {
                var package = JSON.parse(localStorage.getItem('sspp'))
                var priceTier = 1;
              	
                if (cartPrice > 10000) {
                  priceTier = 1 + (Math.ceil((cartPrice - 10000) / 1500))
                }
                var variantSKU = "PPTIER" + priceTier.toString();
                var matchedVariant = package.variants.find(v => v.sku.toLowerCase() === variantSKU.toLowerCase())

                if (matchedVariant == undefined) {
                  matchedVariant = package.variants[package.variants.length - 1]
                }

                return matchedVariant

            },
            getPackageTemplate: function (variant) {
                if (localStorage.getItem('sspp') !== null) {
                    var package = JSON.parse(localStorage.getItem('sspp'))
                    var enabled = (localStorage.getItem('_ssppOption') !== null) ? localStorage.getItem('_ssppOption') : true
                    
                    var packageImgURL = package.featured_image
                    var ppbuild = $('<div>', {
                      class: "form-check form-switch mb-3 pp-container"
                    }).append(
                      $("<input>",{
                        "id":"offcanvas-cart-footer-upsell-checkbox",
                        "class":"form-check-input",
                        "type":"checkbox",
                        "role":"switch",
                        "data-variant-id": variant.id,
                        "checked":(!!JSON.parse(enabled) == true) ? true : false
                		
                      }),
                      $("<label>", { 
                        	"class":"form-check-label small d-flex align-items-center justify-content-between",
                        	"for":"offcanvas-cart-footer-upsell-checkbox"
                      }).append(
                            $('<span class="pp-price">').html(variant.public_title)
                      )
                    )
                    
                    return ppbuild;
                }
            },
            setSSPPHeight: function () {
                var ssppDOM = $('.package-protection-container')
                var ssppDOMFooter = $('.ajaxcart__footer')
                var ssppDOMBody = $('.ajaxcart__inner')
                var ssppDOMParentHeight = ssppDOMFooter.height()

                ssppDOMFooter.css("height", ssppDOMParentHeight + 140)
                ssppDOMBody.css("bottom", ssppDOMParentHeight + 140)

            },
            buildPopupWindow: function () {
                var popupTemplate = $('<div>', {
                    id: "packageProtectionInfoPopup",
                    class: "package-protection-info-popup"
                }).css("display", "none").append(
                    $("<div>", { class: "package-protection-content" }).append(
                        //$("<div>", { class: "title" }).text("PACKAGE PROTECTION"),
                        $("<div>", { class: "title" }).html('<img src="https://labl.s3.amazonaws.com/cdn/images/labl-protect-logo.png">'),
                        $('<p>').html("By opting out of package protection, you are taking on responsibility for this shipment once it is in transit. When the package is in transit without protection, the carrier and the customer become responsible."),
                        $('<p>').html("<br><br>To cover any lost, stolen, or damaged packages, we offer package protection. By opting into package protection, you make it so that we can either place a new order on your behalf or refund you if any of those situations arise, giving you peace of mind."),
                        $('<a>', {
                            class: "package-protection-cancel-btn"
                        }).text("KEEP"),
                        $('<a>', {
                            class: "package-protection-continue-btn"
                        }).text("REMOVE")
                        ,
                        $('<a>', {
                            class: "package-protection-close-btn"
                        }).html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>')
                    )
                )

                return popupTemplate
            },
            getCartTotal: function (cart, removePP) {
                if (removePP && removePP == true) {
                    var cartItemsWithoutIns = cart.items.filter(function (obj) {
                        return obj.vendor !== 'PackageProtection.com' && obj.requires_shipping !== false;
                    });
                    var subTotal = cartItemsWithoutIns.reduce(function (a, b) {
                        return b.final_line_price == null ? a : a + b.final_line_price;
                    }, 0);
                    return subTotal;
                } else {
                    return cart.items_subtotal_price
                }
            },
            confirmTogglePackageProtection: function () {
                $('input#offcanvas-cart-footer-upsell-checkbox').prop('checked', true);
                $('#packageProtectionInfoPopup').show()
            },
            togglePackageProtection: function (cart) {
                var _cartToken = localStorage.setItem('_ssppToken', cart.token)
                var package = JSON.parse(localStorage.getItem('sspp'))
                
                var enabled = (localStorage.getItem('_ssppOption') !== null) ? localStorage.getItem('_ssppOption') : true
                if (!!JSON.parse(enabled) == true){
                    var current_variant = cart.items.find(i => i.product_id === package.id)
                    sspp.removePackageFromCart(current_variant.variant_id)
                    $('#packageProtectionInfoPopup').hide()
                    localStorage.setItem('_ssppOption', false);
                } else {
                    localStorage.setItem('_ssppOption', true);
                    sspp.getCart(ssppCart.updatePackageCart)
                }
            },
            refreshCartList: function () {
              // console.log('***ADJUSTING CART****');
              // fetch(window.location.href)
              // .then(function(response) {
              //     // When the page is loaded convert it to text
              //     return response.text()
              // })
              // .then(function(html) {
              //     var parser = new DOMParser();
              //     var doc = parser.parseFromString(html, "text/html");
          
              //     var docArticle = doc.querySelector('.t4s-mini_cart__items').innerHTML;

              //     $('.t4s-mini_cart__items').html(docArticle)
              // })
              // .catch(function(err) {  
              //     console.log('Failed to fetch page: ', err);  
              // });
            }
        }

        let originalOpen = XMLHttpRequest.prototype.open

        XMLHttpRequest.prototype.open = function () {
            this.addEventListener('loadend', sspp.ajaxLoadEndListener)
            originalOpen.apply(this, arguments)
        }
        
        ns.fetch = function () {
            const response = fetch.apply(this, arguments)

            response.then(res => {
                if ([
                    `${window.location.origin}/cart/add.js`,
                    `${window.location.origin}/cart/update.js`,
                    `${window.location.origin}/cart/change.js`,
                    `${window.location.origin}/cart/clear.js`,
                    `${window.location.origin}/cart/change`,
                    `${window.location.origin}/cart/add`,
                    `${window.location.origin}/cart/update`,
                    `${window.location.origin}/cart/clear`,
                ].includes(res.url)) {
                    res.clone().json().then(data => {
                  		// console.log(data)
                        sspp.getCart(ssppCart.updatePackageCart);
                    })
                }
            })

            return response;
        }

        sspp.init()
                            
    }

    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
            jQuerySSP = jQuery.noConflict(true);
            ssppApp(jQuerySSP);
        });
    } else {
        ssppApp(jQuery);
    }
                  
})(window, window.fetch);